import { FormElementType } from "@plura/shared/types";

export interface FormTemplateTheme {
  backgroundColorSetting: string;
  textColorSetting: string;
  buttonColorSetting: string;
  buttonTextColorSetting: string;
  /** Optional answer-field color; omitted = answer fields follow the button colors. */
  answerColorSetting?: string;
  fontFamilySetting: string;
  elementType: FormElementType;
}

const deepRoseIvory: FormTemplateTheme = {
  backgroundColorSetting: "#7A2F3A",
  textColorSetting: "#FFF6F0",
  buttonColorSetting: "#FFF0EB",
  buttonTextColorSetting: "#7A2F3A",
  fontFamilySetting: "Libre Caslon Text",
  elementType: "ROUNDED",
}

const softBlueClay: FormTemplateTheme = {
  backgroundColorSetting: "#F4FAFF",
  textColorSetting: "#1A2E49",
  buttonColorSetting: "#8A5033",
  buttonTextColorSetting: "#FFF7F2",
  fontFamilySetting: "Playfair Display",
  elementType: "SEMI_ROUNDED",
}

const deepPlumLilac: FormTemplateTheme = {
  backgroundColorSetting: "#644174",
  textColorSetting: "#EDE9F7",
  buttonColorSetting: "#ECE7FB",
  buttonTextColorSetting: "#6A4A7A",
  fontFamilySetting: "Inter Tight",
  elementType: "SEMI_ROUNDED",
}

const navyOrchidGlow: FormTemplateTheme = {
  backgroundColorSetting: "#1F3A5C",
  textColorSetting: "#FFF8F3",
  buttonColorSetting: "#C875E8",
  buttonTextColorSetting: "#FFF8F3",
  fontFamilySetting: "Urbanist",
  elementType: "SQUARED",
}

const spicedCocoaPeach: FormTemplateTheme = {
  backgroundColorSetting: "#6C341A",
  textColorSetting: "#F5F4ED",
  buttonColorSetting: "#FF9C69",
  buttonTextColorSetting: "#1A1A1A",
  fontFamilySetting: "Source Serif 4",
  elementType: "ROUNDED",
}

const emeraldHoneyCream: FormTemplateTheme = {
  backgroundColorSetting: "#1A5A3E",
  textColorSetting: "#FFF7EE",
  buttonColorSetting: "#F7AE5B",
  buttonTextColorSetting: "#1F1B1B",
  fontFamilySetting: "Crimson Pro",
  elementType: "SEMI_ROUNDED",
}

const coralMintBold: FormTemplateTheme = {
  backgroundColorSetting: "#F9C6BC",
  textColorSetting: "#121111",
  buttonColorSetting: "#3FA96C",
  buttonTextColorSetting: "#1A1919",
  fontFamilySetting: "Bebas Neue",
  elementType: "ROUNDED",
}

const forestMintFresh: FormTemplateTheme = {
  backgroundColorSetting: "#A3E2B7",
  textColorSetting: "#103524",
  buttonColorSetting: "#103524",
  buttonTextColorSetting: "#CFF7DB",
  fontFamilySetting: "Plus Jakarta Sans",
  elementType: "ROUNDED",
}

const espressoGoldenSand: FormTemplateTheme = {
  backgroundColorSetting: "#3C3317",
  textColorSetting: "#F9EEDA",
  buttonColorSetting: "#E6D375",
  buttonTextColorSetting: "#2F2812",
  fontFamilySetting: "Plus Jakarta Sans",
  elementType: "ROUNDED",
}

const plumLavenderPop: FormTemplateTheme = {
  backgroundColorSetting: "#DCC6F0",
  textColorSetting: "#654272",
  buttonColorSetting: "#C278E0",
  buttonTextColorSetting: "#FBF7FD",
  fontFamilySetting: "Karla",
  elementType: "ROUNDED",
}

const midnightCoral: FormTemplateTheme = {
  backgroundColorSetting: "#183049",
  textColorSetting: "#F9C7BD",
  buttonColorSetting: "#F9C7BD",
  buttonTextColorSetting: "#152A40",
  fontFamilySetting: "Oswald",
  elementType: "SEMI_ROUNDED",
}

const sunsetGold: FormTemplateTheme = {
  backgroundColorSetting: "#E45D4B",
  textColorSetting: "#F4D876",
  buttonColorSetting: "#F4D876",
  buttonTextColorSetting: "#C84F40",
  fontFamilySetting: "Montserrat",
  elementType: "ROUNDED",
}

const darkMidnight: FormTemplateTheme = {
  backgroundColorSetting: "#171616",
  textColorSetting: "#f2e2d0",
  buttonColorSetting: "#f2e2d0",
  buttonTextColorSetting: "#171616",
  fontFamilySetting: "Plus Jakarta Sans",
  elementType: "ROUNDED",
}

const blackMidnight: FormTemplateTheme = {
  backgroundColorSetting: "#000000",
  textColorSetting: "#f2e2d0",
  buttonColorSetting: "#f2e2d0",
  buttonTextColorSetting: "#000000",
  fontFamilySetting: "Plus Jakarta Sans",
  elementType: "SQUARED",
}

const blueBirchSand: FormTemplateTheme = {
  backgroundColorSetting: "#3862da",
  textColorSetting: "#e9c6ee",
  buttonColorSetting: "#e9c6ee",
  buttonTextColorSetting: "#3862da",
  fontFamilySetting: "Oswald",
  elementType: "SEMI_ROUNDED",
}

export default {
  deepRoseIvory,
  softBlueClay,
  deepPlumLilac,
  navyOrchidGlow,
  spicedCocoaPeach,
  emeraldHoneyCream,
  coralMintBold,
  forestMintFresh,
  espressoGoldenSand,
  plumLavenderPop,
  midnightCoral,
  sunsetGold,
  darkMidnight,
  blueBirchSand,
  blackMidnight,
}

